// src/world/tiles.ts — Definición de tiles (Fase 2)
export type TileKind =
  | 'grass' | 'path' | 'path_alt' | 'water' | 'bridge' | 'tallgrass'
  | 'wall' | 'tree' | 'tree2' | 'rock' | 'fence' | 'flower'
  | 'door' | 'house_floor' | 'plaza' | 'water_deep' | 'sand' | 'cave_floor';

export type TileDef = {
  id: number;
  kind: TileKind;
  walkable: boolean;
  name: string;
  color: string; // base fill
  deco?: string;
};

// IDs numéricos estables (guardado futuro puede referenciarlos)
export const TILE_DEFS: Record<number, TileDef> = {
  0:  { id:0,  kind:'grass',       walkable:true,  name:'Hierba',        color:'#1e3a2d' },
  1:  { id:1,  kind:'path',        walkable:true,  name:'Camino',        color:'#c9b896' },
  2:  { id:2,  kind:'water',       walkable:false, name:'Agua',          color:'#1e6fa8' },
  3:  { id:3,  kind:'wall',        walkable:false, name:'Muro',          color:'#2a2f4a' },
  4:  { id:4,  kind:'tree',        walkable:false, name:'Árbol',         color:'#143624' },
  5:  { id:5,  kind:'tree2',       walkable:false, name:'Árbol grande',  color:'#0f2e1f' },
  6:  { id:6,  kind:'house_floor', walkable:true,  name:'Suelo interior',color:'#d8c9a8' },
  7:  { id:7,  kind:'door',        walkable:true,  name:'Puerta',        color:'#8b5a2b' },
  8:  { id:8,  kind:'flower',      walkable:true,  name:'Flores',        color:'#2a5a3a' },
  9:  { id:9,  kind:'fence',       walkable:false, name:'Valla',         color:'#6b4a2a' },
  10: { id:10, kind:'bridge',      walkable:true,  name:'Puente',        color:'#b8a07a' },
  11: { id:11, kind:'rock',        walkable:false, name:'Roca',          color:'#4a5560' },
  12: { id:12, kind:'tallgrass',   walkable:true,  name:'Hierba alta',   color:'#264a2e' },
  13: { id:13, kind:'cave_floor',  walkable:true,  name:'Suelo cueva',   color:'#3a3a4a' },
  14: { id:14, kind:'plaza',       walkable:true,  name:'Plaza',         color:'#e8dcc0' },
  15: { id:15, kind:'sand',        walkable:true,  name:'Arena',         color:'#d9c48a' },
  16: { id:16, kind:'water_deep',  walkable:false, name:'Agua profunda', color:'#0f4a7a' },
  17: { id:17, kind:'path_alt',    walkable:true,  name:'Sendero',       color:'#b9c4a0' },
};

export function isWalkable(tileId: number): boolean {
  return TILE_DEFS[tileId]?.walkable ?? false;
}

// Mapa char → tileId para edición legible
export const CHAR_TO_TILE: Record<string, number> = {
  'G': 0,  // grass
  'P': 1,  // path
  'W': 2,  // water
  'M': 3,  // wall/muro
  'T': 4,  // tree
  'E': 5,  // tree grande
  'F': 6,  // house floor
  'D': 7,  // door
  'f': 8,  // flower
  'H': 9,  // fence
  'B': 10, // bridge
  'R': 11, // rock
  'h': 12, // tallgrass
  'C': 13, // cave floor
  'A': 14, // plaza
  'S': 15, // sand
  'U': 16, // water deep
  'p': 17, // path alt
};

// Helper: parse layout de strings
export function parseLayout(rows: string[]): number[][] {
  return rows.map(row => [...row].map(ch => CHAR_TO_TILE[ch] ?? 0));
}
